import { breakpoints } from '@bnnvara/breakpoints';
import { globalBorderRadius } from '@bnnvara/themes';
import styled from 'styled-components';
export const Container = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  overflow: hidden;
  border-radius: ${globalBorderRadius} 0 0 ${globalBorderRadius};

  ${({
  isSquare
}) => {
  if (isSquare) {
    return `
        height: 0;
        padding-bottom: 100%;
      `;
  }

  return `
      height: 96px;

      ${breakpoints.md} {
        height: 100%;
        min-height: 329px;
      }
    `;
}}

  ${breakpoints.md} {
    border-radius: ${globalBorderRadius};
  }
`;
export const Background = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;